var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedCheckbox = function SvgCheckedCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 0.758,
    y: 0.5,
    fill: "#0FA457",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.828 7.904 7.64 9.708l4.048-4.025a.627.627 0 0 1 .885.89l-4.521 4.495a.584.584 0 0 1-.823 0L4.943 8.794a.627.627 0 1 1 .885-.89"
  })));
};
export default SvgCheckedCheckbox;